<template>
  <div style="text-align: left;">
    <h2>Login</h2>
    <form @submit.prevent="login">
      <div>
        <label for="username">Username</label><br>
        <input type="text" v-model="username" required />
      </div>
      <div>
        <label for="password">Password</label><br>
        <input type="password" v-model="password" required />
      </div>
      <br>
      <button type="submit">Login</button>
    </form>
    <p v-if="error">{{ error }}</p>
  </div>
</template>

<script>
import config from '../config';

export default {
  setup() {
    return {
      config
    };
  },
  data() {
    return {
      username: "",
      password: "",
      error: null,
    };
  },
  methods: {
    async login() {
      try {
        const response = await fetch(`${ config.apiBaseUrl }/login`, {method: "POST",
          credentials: 'include',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: this.username,
            password: this.password,
          }),
        });

        if (response.ok) {
          const data = await response.json();
          sessionStorage.setItem("jwt", data.token); // Store the JWT in sessionStorage

          const payload = JSON.parse(atob(data.token.split('.')[1])); // Decode the JWT payload to check if the user is admin
          sessionStorage.setItem('is_admin', payload.is_admin);

          this.isLoggedIn = true;

          this.$router.push('/').then(() => {  // Redirect to home, then refresh
            window.location.reload();
          });
          sessionStorage.setItem("username", this.username);
        } else {
          this.error = "Invalid login credentials.";
        }
      } catch (error) {
        console.error("Error during login:", error);
        this.error = "An error occurred. Please try again.";
      }
    },
  },
};
</script>
